import type { RxJsonSchema } from 'rxdb'

/**
 * Checklist Document Type (Denormalized for RxDB)
 */
export interface ChecklistDocument {
  id: string
  envId: string
  taskId: string
  title: string | null
  sortOrder: string | null
  isDeleted: boolean

  // Audit fields
  createdOn: number
  createdBy: string
  updatedOn: number
  updatedBy: string
  deletedOn: number | null
  deletedBy: string | null

  // RxDB replication metadata
  updatedAt?: number
}

/**
 * RxDB Schema for Checklist
 */
export const checklistSchema: RxJsonSchema<ChecklistDocument> = {
  version: 1,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 36,
    },
    envId: {
      type: 'string',
      maxLength: 36,
    },
    taskId: {
      type: 'string',
      maxLength: 36,
    },
    title: {
      type: ['string', 'null'],
      maxLength: 200,
      default: null,
    },
    sortOrder: {
      type: ['string', 'null'],
      maxLength: 100,
    },
    isDeleted: {
      type: 'boolean',
      default: false,
    },

    // Audit fields
    createdOn: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    createdBy: {
      type: 'string',
      maxLength: 36,
    },
    updatedOn: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    updatedBy: {
      type: 'string',
      maxLength: 36,
    },
    deletedOn: {
      type: ['number', 'null'],
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
    deletedBy: {
      type: ['string', 'null'],
      maxLength: 36,
    },

    // RxDB replication metadata
    updatedAt: {
      type: 'number',
      minimum: 0,
      maximum: 9999999999999,
      multipleOf: 1,
    },
  },
  required: [
    'id',
    'envId',
    'taskId',
    'title',
    'isDeleted',
    'createdOn',
    'createdBy',
    'updatedOn',
    'updatedBy',
  ],
  // sortOrder dropped from indexes — RxDB does not support indexes on nullable fields.
  indexes: [
    'envId',
    'taskId',
    'updatedOn',
    ['taskId', 'isDeleted'],
  ],
}

export const checklistMigrationStrategies = {
  // v0 -> v1: sortOrder relaxed to nullable to match backend (string?).
  // Mirror of the moly-mobile fix.
  1: (oldDoc: any): any => oldDoc,
}
